import { useTranslation } from 'react-i18next';

function AccessDenied() {
  const { t } = useTranslation();

  return (
    <div style={{ padding: '50px' }}>
      <h1 style={{ margin: 0 }}>{t('login.accessDenied')}</h1>
      <p>{t('login.contact')}</p>
    </div>
  );
}

export default AccessDenied;
